export const calculateImpressions = (budget, cpm) => {
  if (cpm === 0) {
    return 0;
  }

  return Math.round((budget / cpm) * 1000);
};
